import api from "@/plugins/api";
import axios from "axios";
export class ListSettingsService {
    async getListSettings(entity) {
        try {
            const response = await api.get(`/list-settings/${entity}`, {
                unwrapEnvelope: true,
            });
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    }
    async saveListSettings(entity, settings) {
        await api.put(`/list-settings/${entity}`, settings, {
            unwrapEnvelope: true,
        });
    }
}
